<script setup>
import { Facebook, Instagram, MoveRight, Download, ArrowLeft, ExternalLink, Phone, Mail, Menu, ArrowRight, ChevronDown, ChevronLeft, ChevronRight, X, Trash2, Check, Plus, Minus, Camera, Printer, Save, Trash, ListFilter, LogOut, MapPin, Pencil, Eye, Search, ShoppingBag, Undo, Calendar, Clock, Ticket, Info, CheckCircle, AlertTriangle, XCircle, Loader, PackageX, Settings, Users, UserCheck, TrendingUp, Inbox, Home } from 'lucide-vue-next'
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  size: Number,
  color: String,
  strokeWidth: Number,
  defaultClass: String
})
const icons = { Facebook, Instagram, MoveRight, Download, ArrowLeft, ExternalLink, Phone, Mail, Menu, ArrowRight, ChevronDown, ChevronLeft, ChevronRight, X, Trash2, Check, Plus, Minus, Camera, Printer, Save, Trash, ListFilter, LogOut, MapPin, Pencil, Eye, Search, ShoppingBag, Undo, Calendar, Clock, Ticket, Info, CheckCircle, AlertTriangle, XCircle, Loader, PackageX, Settings, Users, UserCheck, TrendingUp, Inbox, Home }

const toPascalCase = (name) => name.replace(/(^\w|-\w)/g, c => c.replace('-', '').toUpperCase())
const resolvedName = props.name.startsWith('lucide:') ? toPascalCase(props.name.slice(7)) : props.name

if (!icons[resolvedName]) {
  console.log('missing icon', props.name)
}

</script>

<template>
  <component
    :is="icons[resolvedName]"
    :size="size"
    :color="color"
    :stroke-width="strokeWidth"
    :default-class="defaultClass" />
</template>
